function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Icon from '../Icon';

require('xps-style/core/listoption.css');

var propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  selected: PropTypes.bool,
  useCheckbox: PropTypes.bool,
  value: PropTypes.string,
  onClick: PropTypes.func
};
var defaultProps = {
  selected: false
};

var ListOption = function ListOption(_ref) {
  var _cx;

  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      id = _ref.id,
      label = _ref.label,
      selected = _ref.selected,
      useCheckbox = _ref.useCheckbox,
      value = _ref.value,
      onClick = _ref.onClick;

  var _useState = useState(selected),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setSelected = _useState2[1];

  useEffect(function () {
    setSelected(selected);
  }, [selected]);
  var listClasses = cx((_cx = {
    listoption: true,
    'cursor-pointer': !disabled,
    'cursor-not-allowed': disabled,
    'hover-highlight--primary': !disabled,
    'bgcolor--selected': checked && !disabled
  }, _defineProperty(_cx, className, className), _defineProperty(_cx, 'dropdown__item--disabled', disabled), _cx));

  var handleItemSelect = function handleItemSelect(e) {
    var info = {
      value: value,
      label: label,
      selected: !checked
    };
    setSelected(!checked);
    onClick && onClick(info);
  };

  var _onKeyPress = function onKeyPress(e) {
    e.preventDefault();

    if (e.key === 'Enter' || e.key === ' ') {
      handleItemSelect();
    }
  };

  return /*#__PURE__*/React.createElement("li", {
    id: id,
    className: listClasses,
    role: "option",
    "aria-selected": checked,
    "aria-disabled": disabled,
    onClick: function onClick() {
      return !disabled && handleItemSelect();
    },
    onKeyPress: function onKeyPress(e) {
      return !disabled && _onKeyPress(e);
    },
    tabIndex: "-1"
  }, useCheckbox ? /*#__PURE__*/React.createElement("div", {
    className: "display-flex width-100p"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "listoption__checkbox icon--size-16",
    name: checked ? 'checkbox_checked' : 'checkbox_unchecked'
  }), children || label) : children || label);
};

ListOption.propTypes = propTypes;
ListOption.defaultProps = defaultProps;
ListOption.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ListOption",
  "props": {
    "selected": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "useCheckbox": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
export default ListOption;